<div class="alternative-content">
    <div class="alternative-content-card">
        <div class="alternative-content-image" *ngIf="config?.imageSrc">
            <img [src]="resolvedImageSrc" [alt]="(config?.imageAlt || 'Alternative content image') | translate" />

            <div class="alternative-content-icon" *ngIf="config?.iTablerIcon && !config?.imageSrc">
                <i-tabler [name]="config?.iTablerIcon || ''" class="icon-48"></i-tabler>
            </div>

            <div class="alternative-content-body">
                <div *ngIf="config?.title" class="alternative-content-title">
                    {{ (config?.title || '') | translate }}
                </div>
                <div class="alternative-content-description">
                    {{ (config?.description || '') | translate }}

                    <div class="alternative-content-actions" *ngIf="config?.actions as actions">
                        <ng-container *ngFor="let action of actions; let i = index">
                            <!-- Botón simple (actionType === "button" o default) -->
                            <button *ngIf="(action.actionType ?? 'button') === 'button'" type="button"
                                [attr.data-tour]="action.dataTour || null" [ngClass]="getActionClasses(action)"
                                [disabled]="isActionDisabled(action)" (click)="onAction(action)">
                                <i-tabler *ngIf="action.icon" [name]="action.icon" class="action-icon"></i-tabler>
                                <span>{{ action.label | translate }}</span>
                            </button>

                            <!-- Dropdown (actionType === "dropdown") -->
                            <ng-container *ngIf="(action.actionType ?? 'button') === 'dropdown'">
                                <button type="button" [attr.data-tour]="action.dataTour || null"
                                    [ngClass]="getActionClasses(action)" [disabled]="isActionDisabled(action)"
                                    [matMenuTriggerFor]="actionMenu" aria-haspopup="true"
                                    (click)="$event.stopPropagation()">
                                    <i-tabler *ngIf="action.icon" [name]="action.icon" class="action-icon"></i-tabler>
                                    <span>{{ action.label | translate }}</span>
                                </button>

                                <mat-menu [attr.id]="'actionMenu-' + i" #actionMenu="matMenu" class="alternative-provider-menu">
                                    <button type="button" mat-menu-item *ngFor="let child of action.children"
                                        [disabled]="isActionDisabled(child)" (click)="onAction(child)"
                                        [class.alternative-provider-menu-item]="child.showProviderLogo"
                                        [matTooltip]="child.showProviderLogo ? (child.label | translate) : null">
                                        <ng-container *ngIf="child.showProviderLogo && child.providerValue; else childActionLabel">
                                            <span class="alternative-provider-logo" [attr.aria-label]="child.label | translate">
                                                <ng-container *ngIf="isAmazonProvider(child.providerValue); else providerLogo">
                                                    <span class="provider-logo-wrap">
                                                        <img class="provider-logo provider-logo--light"
                                                            src="assets/images/providers-logos/amazon.png"
                                                            [alt]="child.label | translate" />
                                                        <img class="provider-logo provider-logo--dark"
                                                            src="assets/images/providers-logos/amazon-white.png"
                                                            [alt]="child.label | translate" />
                                                    </span>
                                                </ng-container>
                                                <ng-template #providerLogo>
                                                    <img class="provider-logo" [src]="getProviderLogo(child.providerValue)"
                                                        [alt]="child.label | translate" />
                                                </ng-template>
                                            </span>
                                        </ng-container>
                                        <ng-template #childActionLabel>
                                            <span
                                                class="d-flex justify-content-center align-items-center alternative-children-action gap-3">
                                                <i-tabler *ngIf="child.icon" [name]="child.icon"
                                                    class="action-icon d-flex justify-content-center align-items-center"></i-tabler>
                                                <span>{{ child.label | translate }}</span>
                                            </span>
                                        </ng-template>
                                    </button>
                                </mat-menu>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>